var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c99d6d4f01b38b52c8cd00f2ce17ae0de7ca1db6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["keune@ask-phill"]={id:"c99d6d4f01b38b52c8cd00f2ce17ae0de7ca1db6"};
      